import { connect } from "react-redux";
import moment from "moment-timezone";
import React, { Component } from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import { isCareTeamRestricted } from "@/utils/scheduleUtils";
import { Link, PageBanner, Text, TextColors, TextTypes } from "@/component-library";
import { PaywallReminder } from "@/features/dashboard/components/reminder-banner/PaywallReminder";
import { ReminderContainer } from "@/features/dashboard/components/reminder-banner/ReminderContainer";
import { scheduleRequests } from "@/api/(requests)/schedule";
import { setDynamicRouteConfiguration } from "@/redux/actions/navbar";
import { sharedRequests } from "@/api/(requests)/shared";

import AvailableSchedulesList from "./components/AvailableSchedulesList/AvailableSchedulesList";

class SchedulesAvailable extends Component {
  state = {
    isAddNewDisabled: true,
    scheduleList: null,
    scheduleLoaded: false,
  };

  deleteSchedule = (callId, data) => {
    /**
     * api call below returnx promise,
     * so we return that promise again to take decision in the concerned component.
     */
    return sharedRequests.remove_appointment({
      data,
      searchParams: { callId },
    });
  };

  fetchScheduleList = async () => {
    const response = await scheduleRequests.get_schedule({
      context: { showLoader: false },
      searchParams: {
        local_start_date_time: moment().startOf("day").format("YYYY-MM-DD HH:mm"),
        timezone: moment.tz.guess(),
      },
    });
    const scheduleList = response.schedule;
    let isAddNewDisabled = true;

    if (this.props.profile && this.props.configs) {
      const { assessment_config, assessment_status, initial_video_consult } = this.props.profile;
      const { skip_a5_for_referral } = assessment_config || {};

      isAddNewDisabled =
        !assessment_status ||
        (assessment_status && !initial_video_consult && scheduleList.length > 0);

      if (skip_a5_for_referral && !initial_video_consult && scheduleList.length === 0) {
        isAddNewDisabled = false;
      }
    }

    if (scheduleList) {
      this.setState({
        isAddNewDisabled,
        scheduleList,
        scheduleLoaded: true,
      });
    }
  };

  componentDidMount() {
    const dynamicRouteConfig = {};

    dynamicRouteConfig["logoSection"] = { title: "Schedule" };
    this.props.setDynamicRouteConfiguration(dynamicRouteConfig);
    this.fetchScheduleList();
  }

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
  }

  getIsAddNewDisabled() {
    const canAddNew = this.state.isAddNewDisabled;
    const { is_wait_listed } = this.props?.profile || {};

    const isWaitlisted =
      is_wait_listed &&
      this.props.profile?.care_team_members?.reduce((prevVal, member) => {
        return prevVal && isCareTeamRestricted(member["type"], this.props.profile);
      }, true);

    return canAddNew || isWaitlisted;
  }

  isSchedulingRestricted() {
    return this.props.profile?.is_scheduling_restricted;
  }

  render() {
    const { patientCardInfo } = this.props;
    const { showPaywall } = patientCardInfo ?? {};

    if (this.props.profile.status === "INACTIVE") {
      this.props.history.push("/app/schedule/inactive");
    }

    return (
      <div data-public="true">
        <ReminderContainer>
          {showPaywall && <PaywallReminder />}

          {this.isSchedulingRestricted() && !showPaywall && (
            <PageBanner
              className="SchedulingRestrictedBanner d-flex flex-column margin-center tw:m-0! tw:max-w-[unset]!"
              {...getAutomationDataAttr("member-scheduling-scheduling-restricted")}
            >
              <Text className="align-self-baseline" color={TextColors.black} type={TextTypes.label}>
                Your scheduling options have changed
              </Text>

              <Text
                className="align-self-baseline"
                color={TextColors.black}
                type={TextTypes.paragraph}
              >
                To schedule/reschedule therapy sessions, contact your provider. To
                schedule/reschedule medication management sessions, contact{" "}
                <Link className="apti-green-v2" href="mailto:support@aptihealth.com">
                  support@aptihealth.com
                </Link>
              </Text>
            </PageBanner>
          )}
        </ReminderContainer>

        <AvailableSchedulesList
          deleteShedule={this.deleteSchedule}
          fetchUpdatedSchedules={this.fetchScheduleList}
          isAddNewDisabled={this.getIsAddNewDisabled() || this.isSchedulingRestricted()}
          scheduleLoaded={this.state.scheduleLoaded}
          schedules={this.state.scheduleList}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    configs: state.configs,
    flags: state.flags,
    patientCardInfo: state.patientCardInfo,
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps, { setDynamicRouteConfiguration })(SchedulesAvailable);
